import { Step, StepContent, StepIconProps, StepLabel, Stepper } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { TimelineItemModel } from "react-chrono/dist/models/TimelineItemModel";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { Button, Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { CoursesListDisplayType } from "../../../../models/coursesListDisplayType";
import { TrainingPathTanslationDto } from "../../../../models/trainingPathTranslationDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import Breadcrumbs from "../../../../shared/breadcrumb/breadCrumb";
import { useStyles } from "../../../../shared/timeline-utils/steps-icons";
import { RootState } from "../../../../store";
import CourseList from "../course/course";
import TrainingPathTimeline from "../training-path-timeline/trainingPathTimeline";
import styles from "./module-starting.module.scss";
import { translate } from "react-switch-lang";

const ModuleStarting: React.FC<{ t: (key: string) => string }> = props => {
  const [moduleItems, setModuleItems] = useState<Array<TimelineItemModel>>([] as TimelineItemModel[]);
  const params = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState("1");
  const keycloak = useKeycloak().keycloak;
  const httpClient = useHttpClient(keycloak.authenticated);
  const currentLang = useSelector((state: RootState) => state.language.currentLang);
  const [currentTrainingPath, setCurrentTrainingPath] = useState<TrainingPathTanslationDto>(null);

  const [currentStep, setCurrentStep] = useState(0);
   
  useEffect(() => {
    async function fetchTrainingPath() {
      if (moduleItems.length === 0) {
        getTrainingPathTranslation();
      }
    }
    fetchTrainingPath();
    getStepActive();
    // eslint-disable-next-line
  }, [moduleItems]);

  async function getTrainingPathTranslation() {
    const response = await httpClient.current?.get(`/trainingPathTranslation/trainingPath/${params?.id}`);
    const trainingPathTranslation: TrainingPathTanslationDto = (response.data as TrainingPathTanslationDto[]).find(training => training.language === currentLang.toUpperCase());
    setCurrentTrainingPath(trainingPathTranslation);
    const timelineModelList = Array.from(trainingPathTranslation?.moduleList, async module => {
      return {
        id: module.id.toString(),
        title: module.moduleDuration,
        cardTitle: module.title,
        active: (await httpClient.current.get(`/course/isModuleFinished/${module.id}`)).data,
      } as TimelineItemModel;
    });

    Promise.all(timelineModelList).then(dat => {
      setModuleItems(() => dat);
    });
  }

  function ColorlibStepIcon(props: StepIconProps) {
    const classes = useStyles();
    const { active, completed } = props;
    let stepIcon: any = {};

    moduleItems.forEach((module, index) => {
      stepIcon[index + 1] = <p>{index + 1}</p>;
    });

    const icons: { [index: string]: React.ReactElement } = stepIcon;

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }

  function getStepActive() {
    let index = moduleItems.findIndex(module => !module.active);
    setCurrentStep(index === -1 ? moduleItems.length : index);
  }

  const changeActiveStep = (index: number) => {
    // let firstAvailableIndex = moduleItems.findIndex(module => !module.active);
    if (index === currentStep) {
      setCurrentStep(4);
    } else {
      setCurrentStep(index);
    }
  };

  const updateDownloadNumberOfTrainingPath = () => {
     httpClient.current?.put(`/trainingPath/updateNumberDownload/${params?.id}`);
  };  

  return (
    <>
      <Breadcrumbs parent={props.t("training_path_my_paths")} title={props.t("modules_of_the_training_path")} />
      <Col lg="12 box-col-12" xl="12 xl-100" className={styles["modules_container"]}>
        <Card>
          <CardBody className={styles["user-training-tabs-wrapper"]}>
            <h3>{props.t("modules_of_the_training_path")}</h3>
            <Nav className="border-tab" tabs>
              <NavItem>
                <NavLink className={activeTab === "1" ? `active ${styles["modules-tabs"]}` : ` ${styles["modules-tabs"]}`} onClick={() => setActiveTab("1")}>
                  <span>{props.t("start_the_training_path")}</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={activeTab === "2" ? `active ${styles["modules-tabs"]}` : ` ${styles["modules-tabs"]}`} onClick={() => setActiveTab("2")}>
                  <span>{props.t("modules_monitoring")}</span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane className="fade show" tabId="1">
                <Container fluid={true} className={styles["steps_container"]}>
                  <Row>
                    <Col sm="12" className={styles["stepper_container"]}>
                      <Stepper activeStep={currentStep} orientation="vertical" className={styles["stepper_div"]}>
                        {moduleItems.map((moduleItem, index) => (
                          <Step key={moduleItem.id}>
                            <StepLabel StepIconComponent={ColorlibStepIcon} onClick={() => changeActiveStep(index)}>
                              {moduleItem.cardTitle}
                              <p className={styles["course_duration_div"]}>{moduleItem.title}</p>
                            </StepLabel>
                            <StepContent>
                              <CourseList
                                refreshCourses={getTrainingPathTranslation}
                                coursesListDisplayType={CoursesListDisplayType.TIMELINE}
                                moduleId={Number.parseInt(moduleItem.id)}
                                isTrainingPathUpdate={true}
                              />
                            </StepContent>
                          </Step>
                        ))}
                      </Stepper>
                    </Col>
                  </Row>
                  <Row className={styles["download-wrapper"]}>
                  <a href={`${currentTrainingPath?.offlinePath}/download`}>
                  <Button color="primary" className={styles["down_button"]} onClick={updateDownloadNumberOfTrainingPath} >
                  {props.t("download_the_training_path")}
                  </Button>
                  </a>
                  {moduleItems.filter(item => item.active === false).length === 0 && (
                    <Button color="primary" className={styles["down_button"]}>
                      <a href={`${currentTrainingPath?.supportUrl}/download`}>{props.t("download_the_evaluation")}</a>
                    </Button>
                  )}
                </Row>
                </Container>
              </TabPane>
              <TabPane tabId="2">
                <TrainingPathTimeline items={moduleItems} />
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default translate(ModuleStarting);
